import { FileWithArrowUp } from '../../../../assets/icons/fileWithArrowUp'
import { EmptyTable } from '../../../../pages/subjects/Subject'
import { MAX_URL_LENGTH } from '../../../../pages/subjects/SubjectEdit'
import { FlexBlock } from '../../../customStyledElements'

import { THead } from '../../main/indicators-signals-table/IndicatorsSignalTable'
import { Link } from "react-router-dom";
import {getSubjectId, WarningCircle} from "../../../../pages/biomarkers/[id]/IndicatorsAndSignals";
import { FileWrapper } from '../../main/interpretation/tableComponents'
import {Searchify} from "../../../myTable/MyTable";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import React from "react";

export const Empty = () => {
  return <EmptyTable name={'interpretation'} />
}

export const NothingFound = () => {
  return (
    <tr>
      <td colSpan={1000} className={'nothing-found'}>
        Nothing Found ....
      </td>
    </tr>
  )
}

export const IdRecommendationsHead = () => {
  return (
    <THead>
      <tr>
        <td>Recommendation name</td>
      </tr>
    </THead>
  )
}
export const IdInterpretationHead = () => {
  return (
    <THead>
      <tr>
        <td>Disease name</td>
      </tr>
    </THead>
  )
}

const IDInterpretationWrap = ({type, item, language = 'en'}: {type: string, item: any, language?: string}) => {
  const linkTo = `/${getSubjectId()}/${type}/${item?._id}`
  const itemName = typeof item?.name === 'object' 
    ? item.name[language] || item.name['en'] || Object.values(item.name)[0] || ''
    : item?.name || ''
  return (
      (item && item._id) ? <tbody key={item?._id}>
      <tr>
        <td data-file-down >
            <div data-td-center>
                <FileWrapper to={linkTo} top={5} abs={true}/>
                <Link to={linkTo}>
                    {itemName.slice(0, MAX_URL_LENGTH)}
                    {itemName.slice(MAX_URL_LENGTH)?.length > 0 && ' ...'}
                </Link>
            </div>
        </td>
      </tr>
    </tbody> : null
  )
}

export const IdRecommendationsBody = ({ item, ind, language = 'en' }: any) => {
  return <IDInterpretationWrap type={'recommendations'} item={item} language={language}></IDInterpretationWrap>
}

export const IdInterpreationBody = ({ item, ind, language = 'en' }: any) => {
  return <IDInterpretationWrap type={'diseases'} item={item} language={language}></IDInterpretationWrap>
}